import React from 'react';
import { Link } from 'react-router-dom';
import { useForm } from 'react-hook-form';
import { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import BootstrapSwitchButton from 'bootstrap-switch-button-react';
import {
  UpdateCarWashListing,
  AddMedia,
  getCarWashListing,
} from './../../../../Redux/Actions/UserAction';
import Sidebar from '../../../common/Sidebar/Sidebar';
import { timeOptions } from '../../../../Options';
import { useTranslation } from 'react-i18next';
import { CommonBusinessHeader } from '../CommonBusinessHeader';

const openStatus = ['OPEN', 'مفتوح'];

const CarWashWorkingHours = () => {
  const { t } = useTranslation();

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({ mode: 'all' });

  const home = useSelector((state) => state?.home);
  const CarWashAllList = home?.CarWashAllList;
  const getMybusiness = home?.getMybusiness;

  // The owner's business id may arrive from sessionStorage (set by the Header)
  // or directly from Redux getMybusiness after a reload. Prefer whichever is
  // available so the calendar refetches once the id resolves.
  const ownerBid =
    (getMybusiness?.businessId && String(getMybusiness.businessId)) ||
    sessionStorage.getItem('BusinessId');

  useEffect(() => {
    if (CarWashAllList === undefined && ownerBid) {
      dispatch(getCarWashListing(ownerBid));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ownerBid]);

  const [CarWashData, setCarWashData] = useState({
    calendar: {
      SUNDAY: {
        status: '',
        openTime: '',
        endTime: '',
      },
      MONDAY: {
        status: '',
        openTime: '',
        endTime: '',
      },
      TUESDAY: {
        status: '',
        openTime: '',
        endTime: '',
      },
      WEDNESDAY: {
        status: '',
        openTime: '',
        endTime: '',
      },
      THURSDAY: {
        status: '',
        openTime: '',
        endTime: '',
      },
      FRIDAY: {
        status: '',
        openTime: '',
        endTime: '',
      },
      SATURDAY: {
        status: '',
        openTime: '',
        endTime: '',
      },
    },

    // mediaIds: {
    // 	BANNER: [''],
    // },
  });

  const CarWastData = CarWashAllList?.[0];

  useEffect(() => {
    if (CarWastData && Object.keys(CarWastData).length > 0) {
      let calendar;
      try {
        calendar =
          typeof CarWastData?.calendar === 'string'
            ? JSON.parse(CarWastData?.calendar)
            : CarWastData?.calendar;
      } catch (e) {
        calendar = undefined;
      }
      setCarWashData({
        calendar: {
          SUNDAY: {
            status: calendar?.SUNDAY?.status,
            openTime: calendar?.SUNDAY?.openTime,
            endTime: calendar?.SUNDAY?.endTime,
          },
          MONDAY: {
            status: calendar?.MONDAY?.status,
            openTime: calendar?.MONDAY?.openTime,
            endTime: calendar?.MONDAY?.endTime,
          },
          TUESDAY: {
            status: calendar?.TUESDAY?.status,
            openTime: calendar?.TUESDAY?.openTime,
            endTime: calendar?.TUESDAY?.endTime,
          },
          WEDNESDAY: {
            status: calendar?.WEDNESDAY?.status,
            openTime: calendar?.WEDNESDAY?.openTime,
            endTime: calendar?.WEDNESDAY?.endTime,
          },
          THURSDAY: {
            status: calendar?.THURSDAY?.status,
            openTime: calendar?.THURSDAY?.openTime,
            endTime: calendar?.THURSDAY?.endTime,
          },
          FRIDAY: {
            status: calendar?.FRIDAY?.status,
            openTime: calendar?.FRIDAY?.openTime,
            endTime: calendar?.FRIDAY?.endTime,
          },
          SATURDAY: {
            status: calendar?.SATURDAY?.status,
            openTime: calendar?.SATURDAY?.openTime,
            endTime: calendar?.SATURDAY?.endTime,
          },
        },
      });
    }
  }, [CarWashAllList]);

  // setMessage(prevState => ({
  // 	input: {
  // 		...prevState.input,
  // 		message: {
  // 			...prevState.input.message,
  // 			text: 'My message',
  // 		},
  // 	},
  // }));

  const handleChange = (e) => {
    // console.log('e is the id', e.target.id);
    console.log('e is the value', e);

    // console.log('e is the checked', e.target.checked);

    if (e.target.id === 'SUNDAY') {
      // console.log('e is the best', e.target.id);
      setCarWashData({
        ...CarWashData,
        calendar: {
          ...CarWashData?.calendar,
          SUNDAY: {
            ...CarWashData?.calendar?.SUNDAY,
            [e.target.name]: e.target.value,
          },
        },
      });
    } else if (e.target.id === 'MONDAY') {
      setCarWashData({
        ...CarWashData,
        calendar: {
          ...CarWashData?.calendar,
          MONDAY: {
            ...CarWashData?.calendar?.MONDAY,
            [e.target.name]: e.target.value,
          },
        },
      });
    } else if (e.target.id === 'TUESDAY') {
      setCarWashData({
        ...CarWashData,
        calendar: {
          ...CarWashData?.calendar,
          TUESDAY: {
            ...CarWashData?.calendar?.TUESDAY,
            [e.target.name]: e.target.value,
          },
        },
      });
    } else if (e.target.id === 'WEDNESDAY') {
      setCarWashData({
        ...CarWashData,
        calendar: {
          ...CarWashData?.calendar,
          WEDNESDAY: {
            ...CarWashData?.calendar?.WEDNESDAY,
            [e.target.name]: e.target.value,
          },
        },
      });
    } else if (e.target.id === 'THURSDAY') {
      setCarWashData({
        ...CarWashData,
        calendar: {
          ...CarWashData?.calendar,
          THURSDAY: {
            ...CarWashData?.calendar?.THURSDAY,
            [e.target.name]: e.target.value,
          },
        },
      });
    } else if (e.target.id === 'FRIDAY') {
      setCarWashData({
        ...CarWashData,
        calendar: {
          ...CarWashData?.calendar,
          FRIDAY: {
            ...CarWashData?.calendar?.FRIDAY,
            [e.target.name]: e.target.value,
          },
        },
      });
    } else if (e.target.id === 'SATURDAY') {
      setCarWashData({
        ...CarWashData,
        calendar: {
          ...CarWashData?.calendar,
          SATURDAY: {
            ...CarWashData?.calendar?.SATURDAY,
            [e.target.name]: e.target.value,
          },
        },
      });
    }
  };
  // function handleChange(e) {
  // 	const { name, value } = e.target;
  // 	setCarWashData
  // user => ({ ...user, [name]: value });// }

  const dispatch = useDispatch();

  const datasubmit = () => {
    console.log('tihs is image section', CarWashData);
    dispatch(UpdateCarWashListing(CarWashData));
  };
  const ResetHendler = () => {
    setCarWashData({
      calendar: {
        SUNDAY: {
          status: 'CLOSE',
          openTime: '',
          endTime: '',
        },
        MONDAY: {
          status: 'CLOSE',
          openTime: '',
          endTime: '',
        },
        TUESDAY: {
          status: 'CLOSE',
          openTime: '',
          endTime: '',
        },
        WEDNESDAY: {
          status: 'CLOSE',
          openTime: '',
          endTime: '',
        },
        THURSDAY: {
          status: 'CLOSE',
          openTime: '',
          endTime: '',
        },
        FRIDAY: {
          status: 'CLOSE',
          openTime: '',
          endTime: '',
        },
        SATURDAY: {
          status: 'CLOSE',
          openTime: '',
          endTime: '',
        },
      },
    });
  };

  const sideBarOpt = [
    {
      icon: 'assets/images/icons/sp-business/manage-business.svg',
      link: '/sp-car-wash-business',
      label: t('Manage Business'),
    },
    {
      icon: 'assets/images/icons/sp-business/manage-service.svg',
      link: '/sp-car-wash-packages',
      label: t('Manage Packages'),
    },
    {
      icon: 'assets/images/icons/sp-business/banner.svg',
      link: '/sp-car-wash-banner',
      label: t('Banner'),
    },
    {
      icon: 'assets/images/icons/sp-business/manage-working-hours.svg',
      link: '/sp-car-wash-working-hours',
      label: t('Manage Working Hours'),
    },
  ];

  console.log('CarWashAllList', CarWashAllList);
  return (
    <div>
      <CommonBusinessHeader
        dataList={CarWashAllList}
        getNameKey="carWashName"
      />
      <div class="main-content-area">
        <div class="container">
          <div class="row justify-content-between">
            <Sidebar options={sideBarOpt} />
            <div class="col-12 col-sm-12 col-md-9 col-lg-9">
              <h2 class="mb-4">{t('Manage Working Hours')}</h2>
              <form onSubmit={handleSubmit(datasubmit)}>
                <div class="mwh-row">
                  <div class="row align-items-center">
                    <div class="col-12 col-sm-12 col-md-3 mb-2 mb-sm-2 mb-md-0">
                      <div class="mwh-day">{t('Day')}</div>
                    </div>
                    <div class="col-5 col-sm-5 col-md-3 mb-2 mb-sm-2 mb-md-0">
                      <label class="mwh-day">{t('From')}</label>
                    </div>
                    <div class="col-4 col-sm-4 col-md-3 mb-2 mb-sm-2 mb-md-0">
                      <label class="mwh-day">{t('To')}</label>
                    </div>
                  </div>
                </div>
                <div class="mwh-row">
                  <div class="row align-items-center">
                    <div class="col-12 col-sm-12 col-md-3 mb-2 mb-sm-2 mb-md-0">
                      <div class="mwh-day">{t('Sunday')}</div>
                    </div>

                    <div class="col-5 col-sm-5 col-md-3 mb-2 mb-sm-2 mb-md-0">
                      <label class="sr-only">{t('From')}</label>
                      <select
                        class="form-control"
                        name="openTime"
                        id="SUNDAY"
                        value={CarWashData?.calendar?.SUNDAY?.openTime}
                        onChange={handleChange}
                        disabled={
                          !openStatus.includes(
                            CarWashData.calendar.SUNDAY.status
                          )
                        }
                      >
                        <option>{t('From')}</option>
                        {timeOptions?.map((opt, index) => (
                          <option key={index}>{opt?.label}</option>
                        ))}
                      </select>
                    </div>

                    <div class="col-4 col-sm-4 col-md-3 mb-2 mb-sm-2 mb-md-0">
                      <label class="sr-only">{t('From')}</label>
                      <select
                        class="form-control"
                        id="SUNDAY"
                        name="endTime"
                        value={CarWashData?.calendar?.SUNDAY?.endTime}
                        onChange={handleChange}
                        disabled={
                          !openStatus.includes(
                            CarWashData.calendar.SUNDAY.status
                          )
                        }
                      >
                        <option>{t('To')}</option>
                        {timeOptions?.map((opt, index) => (
                          <option key={index}>{opt?.label}</option>
                        ))}
                      </select>
                    </div>

                    <div class="col-3 col-sm-3 col-md-3 mb-2 mb-sm-2 mb-md-0">
                      <div class="mwh-switch">
                        <div class="form-check form-check-inline">
                          <BootstrapSwitchButton
                            width={70}
                            checked={
                              openStatus.includes(
                                CarWashData.calendar.SUNDAY.status
                              )
                                ? true
                                : false
                            }
                            onstyle="warning"
                            onlabel={t('open')}
                            offlabel={t('close')}
                            name="status"
                            id="SUNDAY"
                            onChange={(checked) => {
                              setCarWashData({
                                ...CarWashData,
                                calendar: {
                                  ...CarWashData?.calendar,
                                  SUNDAY: {
                                    ...CarWashData?.calendar?.SUNDAY,

                                    status: checked ? 'OPEN' : 'CLOSE',
                                  },
                                },
                              });
                            }}
                            // value={CarWashData.status}
                          />
                          {/* <input
														class='form-check-input'
														type='checkbox'
														id='inlineCheckbox1'
														value='option1'
													/> */}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="mwh-row">
                  <div class="row align-items-center">
                    <div class="col-12 col-sm-12 col-md-3 mb-2 mb-sm-2 mb-md-0">
                      <div class="mwh-day">{t('Monday')}</div>
                    </div>

                    <div class="col-5 col-sm-5 col-md-3 mb-2 mb-sm-2 mb-md-0">
                      <label class="sr-only">{t('From')}</label>
                      <select
                        class="form-control"
                        name="openTime"
                        id="MONDAY"
                        value={CarWashData?.calendar?.MONDAY?.openTime}
                        onChange={handleChange}
                        disabled={
                          !openStatus.includes(
                            CarWashData.calendar.MONDAY.status
                          )
                        }
                      >
                        <option>{t('From')}</option>
                        {timeOptions?.map((opt, index) => (
                          <option key={index}>{opt?.label}</option>
                        ))}
                      </select>
                    </div>

                    <div class="col-4 col-sm-4 col-md-3 mb-2 mb-sm-2 mb-md-0">
                      <label class="sr-only">{t('From')}</label>
                      <select
                        class="form-control"
                        id="MONDAY"
                        name="endTime"
                        value={CarWashData?.calendar?.MONDAY?.endTime}
                        onChange={handleChange}
                        disabled={
                          !openStatus.includes(
                            CarWashData.calendar.MONDAY.status
                          )
                        }
                      >
                        <option>{t('To')}</option>
                        {timeOptions?.map((opt, index) => (
                          <option key={index}>{opt?.label}</option>
                        ))}
                      </select>
                    </div>

                    <div class="col-3 col-sm-3 col-md-3 mb-2 mb-sm-2 mb-md-0">
                      <div class="mwh-switch">
                        <div class="form-check form-check-inline">
                          <BootstrapSwitchButton
                            width={70}
                            checked={
                              openStatus.includes(
                                CarWashData.calendar.MONDAY.status
                              )
                                ? true
                                : false
                            }
                            onstyle="warning"
                            onlabel={t('open')}
                            offlabel={t('close')}
                            name="status"
                            id="MONDAY"
                            onChange={(checked) => {
                              setCarWashData({
                                ...CarWashData,
                                calendar: {
                                  ...CarWashData?.calendar,
                                  MONDAY: {
                                    ...CarWashData?.calendar?.MONDAY,

                                    status: checked ? 'OPEN' : 'CLOSE',
                                  },
                                },
                              });
                            }}

                            // value={CarWashData.status}
                          />
                          {/* <input
														class='form-check-input'
														type='checkbox'
														id='inlineCheckbox2'
														value='option2'
													/> */}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="mwh-row">
                  <div class="row align-items-center">
                    <div class="col-12 col-sm-12 col-md-3 mb-2 mb-sm-2 mb-md-0">
                      <div class="mwh-day">{t('Tuesday')}</div>
                    </div>

                    <div class="col-5 col-sm-5 col-md-3 mb-2 mb-sm-2 mb-md-0">
                      <label class="sr-only">{t('From')}</label>
                      <select
                        class="form-control"
                        name="openTime"
                        id="TUESDAY"
                        value={CarWashData?.calendar?.TUESDAY?.openTime}
                        onChange={handleChange}
                        disabled={
                          !openStatus.includes(
                            CarWashData.calendar.TUESDAY.status
                          )
                        }
                      >
                        <option>{t('From')}</option>
                        {timeOptions?.map((opt, index) => (
                          <option key={index}>{opt?.label}</option>
                        ))}
                      </select>
                    </div>

                    <div class="col-4 col-sm-4 col-md-3 mb-2 mb-sm-2 mb-md-0">
                      <label class="sr-only">{t('From')}</label>
                      <select
                        class="form-control"
                        id="TUESDAY"
                        name="endTime"
                        value={CarWashData?.calendar?.TUESDAY?.endTime}
                        onChange={handleChange}
                        disabled={
                          !openStatus.includes(
                            CarWashData.calendar.TUESDAY.status
                          )
                        }
                      >
                        <option>{t('To')}</option>
                        {timeOptions?.map((opt, index) => (
                          <option key={index}>{opt?.label}</option>
                        ))}
                      </select>
                    </div>

                    <div class="col-3 col-sm-3 col-md-3 mb-2 mb-sm-2 mb-md-0">
                      <div class="mwh-switch">
                        <div class="form-check form-check-inline">
                          <BootstrapSwitchButton
                            width={70}
                            checked={
                              openStatus.includes(
                                CarWashData.calendar.TUESDAY.status
                              )
                                ? true
                                : false
                            }
                            onstyle="warning"
                            onlabel={t('open')}
                            offlabel={t('close')}
                            name="status"
                            id="TUESDAY"
                            onChange={(checked) => {
                              setCarWashData({
                                ...CarWashData,
                                calendar: {
                                  ...CarWashData?.calendar,
                                  TUESDAY: {
                                    ...CarWashData?.calendar?.TUESDAY,

                                    status: checked ? 'OPEN' : 'CLOSE',
                                  },
                                },
                              });
                            }}

                            // value={CarWashData.status}
                          />
                          {/* <input
														class='form-check-input'
														type='checkbox'
														id='inlineCheckbox3'
														value='option3'
													/> */}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="mwh-row">
                  <div class="row align-items-center">
                    <div class="col-12 col-sm-12 col-md-3 mb-2 mb-sm-2 mb-md-0">
                      <div class="mwh-day">{t('Wednesday')}</div>
                    </div>

                    <div class="col-5 col-sm-5 col-md-3 mb-2 mb-sm-2 mb-md-0">
                      <label class="sr-only">{t('From')}</label>
                      <select
                        class="form-control"
                        name="openTime"
                        id="WEDNESDAY"
                        value={CarWashData?.calendar?.WEDNESDAY?.openTime}
                        onChange={handleChange}
                        disabled={
                          !openStatus.includes(
                            CarWashData.calendar.WEDNESDAY.status
                          )
                        }
                      >
                        <option>{t('From')}</option>
                        {timeOptions?.map((opt, index) => (
                          <option key={index}>{opt?.label}</option>
                        ))}
                      </select>
                    </div>

                    <div class="col-4 col-sm-4 col-md-3 mb-2 mb-sm-2 mb-md-0">
                      <label class="sr-only">{t('From')}</label>
                      <select
                        class="form-control"
                        id="WEDNESDAY"
                        name="endTime"
                        value={CarWashData?.calendar?.WEDNESDAY?.endTime}
                        onChange={handleChange}
                        disabled={
                          !openStatus.includes(
                            CarWashData.calendar.WEDNESDAY.status
                          )
                        }
                      >
                        <option>{t('To')}</option>
                        {timeOptions?.map((opt, index) => (
                          <option key={index}>{opt?.label}</option>
                        ))}
                      </select>
                    </div>

                    <div class="col-3 col-sm-3 col-md-3 mb-2 mb-sm-2 mb-md-0">
                      <div class="mwh-switch">
                        <div class="form-check form-check-inline">
                          <BootstrapSwitchButton
                            width={70}
                            checked={
                              openStatus.includes(
                                CarWashData.calendar.WEDNESDAY.status
                              )
                                ? true
                                : false
                            }
                            onstyle="warning"
                            onlabel={t('open')}
                            offlabel={t('close')}
                            name="status"
                            id="WEDNESDAY"
                            onChange={(checked) => {
                              setCarWashData({
                                ...CarWashData,
                                calendar: {
                                  ...CarWashData?.calendar,
                                  WEDNESDAY: {
                                    ...CarWashData?.calendar?.WEDNESDAY,

                                    status: checked ? 'OPEN' : 'CLOSE',
                                  },
                                },
                              });
                            }}

                            // value={CarWashData.status}
                          />
                          {/* <input
														class='form-check-input'
														type='checkbox'
														id='inlineCheckbox4'
														value='option4'
													/> */}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="mwh-row">
                  <div class="row align-items-center">
                    <div class="col-12 col-sm-12 col-md-3 mb-2 mb-sm-2 mb-md-0">
                      <div class="mwh-day">{t('Thursday')}</div>
                    </div>

                    <div class="col-5 col-sm-5 col-md-3 mb-2 mb-sm-2 mb-md-0">
                      <label class="sr-only">{t('From')}</label>
                      <select
                        class="form-control"
                        name="openTime"
                        id="THURSDAY"
                        value={CarWashData?.calendar?.THURSDAY?.openTime}
                        onChange={handleChange}
                        disabled={
                          !openStatus.includes(
                            CarWashData.calendar.THURSDAY.status
                          )
                        }
                      >
                        <option>{t('From')}</option>
                        {timeOptions?.map((opt, index) => (
                          <option key={index}>{opt?.label}</option>
                        ))}
                      </select>
                    </div>

                    <div class="col-4 col-sm-4 col-md-3 mb-2 mb-sm-2 mb-md-0">
                      <label class="sr-only">{t('From')}</label>
                      <select
                        class="form-control"
                        id="THURSDAY"
                        name="endTime"
                        value={CarWashData?.calendar?.THURSDAY?.endTime}
                        onChange={handleChange}
                        disabled={
                          !openStatus.includes(
                            CarWashData.calendar.THURSDAY.status
                          )
                        }
                      >
                        <option>{t('To')}</option>
                        {timeOptions?.map((opt, index) => (
                          <option key={index}>{opt?.label}</option>
                        ))}
                      </select>
                    </div>

                    <div class="col-3 col-sm-3 col-md-3 mb-2 mb-sm-2 mb-md-0">
                      <div class="mwh-switch">
                        <div class="form-check form-check-inline">
                          <BootstrapSwitchButton
                            width={70}
                            checked={
                              openStatus.includes(
                                CarWashData.calendar.THURSDAY.status
                              )
                                ? true
                                : false
                            }
                            onstyle="warning"
                            onlabel={t('open')}
                            offlabel={t('close')}
                            name="status"
                            id="THURSDAY"
                            onChange={(checked) => {
                              setCarWashData({
                                ...CarWashData,
                                calendar: {
                                  ...CarWashData?.calendar,
                                  THURSDAY: {
                                    ...CarWashData?.calendar?.THURSDAY,

                                    status: checked ? 'OPEN' : 'CLOSE',
                                  },
                                },
                              });
                            }}
                            // value={CarWashData.status}
                          />
                          {/* <input
														class='form-check-input'
														type='checkbox'
														id='inlineCheckbox5'
														value='option5'
													/> */}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="mwh-row">
                  <div class="row align-items-center">
                    <div class="col-12 col-sm-12 col-md-3 mb-2 mb-sm-2 mb-md-0">
                      <div class="mwh-day">{t('Friday')}</div>
                    </div>

                    <div class="col-5 col-sm-5 col-md-3 mb-2 mb-sm-2 mb-md-0">
                      <label class="sr-only">{t('From')}</label>
                      <select
                        class="form-control"
                        name="openTime"
                        id="FRIDAY"
                        value={CarWashData?.calendar?.FRIDAY?.openTime}
                        onChange={handleChange}
                        disabled={
                          !openStatus.includes(
                            CarWashData.calendar.FRIDAY.status
                          )
                        }
                      >
                        <option>{t('From')}</option>
                        {timeOptions?.map((opt, index) => (
                          <option key={index}>{opt?.label}</option>
                        ))}
                      </select>
                    </div>

                    <div class="col-4 col-sm-4 col-md-3 mb-2 mb-sm-2 mb-md-0">
                      <label class="sr-only">{t('From')}</label>
                      <select
                        class="form-control"
                        id="FRIDAY"
                        name="endTime"
                        value={CarWashData?.calendar?.FRIDAY?.endTime}
                        onChange={handleChange}
                        disabled={
                          !openStatus.includes(
                            CarWashData.calendar.FRIDAY.status
                          )
                        }
                      >
                        <option>{t('To')}</option>
                        {timeOptions?.map((opt, index) => (
                          <option key={index}>{opt?.label}</option>
                        ))}
                      </select>
                    </div>

                    <div class="col-3 col-sm-3 col-md-3 mb-2 mb-sm-2 mb-md-0">
                      <div class="mwh-switch">
                        <div class="form-check form-check-inline">
                          <BootstrapSwitchButton
                            width={70}
                            checked={
                              openStatus.includes(
                                CarWashData.calendar.FRIDAY.status
                              )
                                ? true
                                : false
                            }
                            onstyle="warning"
                            onlabel={t('open')}
                            offlabel={t('close')}
                            name="status"
                            id="FRIDAY"
                            onChange={(checked) => {
                              setCarWashData({
                                ...CarWashData,
                                calendar: {
                                  ...CarWashData?.calendar,
                                  FRIDAY: {
                                    ...CarWashData?.calendar?.FRIDAY,

                                    status: checked ? 'OPEN' : 'CLOSE',
                                  },
                                },
                              });
                            }}
                            // value={CarWashData.status}
                          />
                          {/* <input
														class='form-check-input'
														type='checkbox'
														id='inlineCheckbox6'
														value='option6'
													/> */}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="mwh-row">
                  <div class="row align-items-center">
                    <div class="col-12 col-sm-12 col-md-3 mb-2 mb-sm-2 mb-md-0">
                      <div class="mwh-day">{t('Saturday')}</div>
                    </div>

                    <div class="col-5 col-sm-5 col-md-3 mb-2 mb-sm-2 mb-md-0">
                      <label class="sr-only">{t('From')}</label>
                      <select
                        class="form-control"
                        name="openTime"
                        id="SATURDAY"
                        value={CarWashData?.calendar?.SATURDAY?.openTime}
                        onChange={handleChange}
                        disabled={
                          !openStatus.includes(
                            CarWashData.calendar.SATURDAY.status
                          )
                        }
                      >
                        <option>{t('From')}</option>
                        {timeOptions?.map((opt, index) => (
                          <option key={index}>{opt?.label}</option>
                        ))}
                      </select>
                    </div>

                    <div class="col-4 col-sm-4 col-md-3 mb-2 mb-sm-2 mb-md-0">
                      <label class="sr-only">{t('From')}</label>
                      <select
                        class="form-control"
                        id="SATURDAY"
                        name="endTime"
                        value={CarWashData?.calendar?.SATURDAY?.endTime}
                        onChange={handleChange}
                        disabled={
                          !openStatus.includes(
                            CarWashData.calendar.SATURDAY.status
                          )
                        }
                      >
                        <option>{t('To')}</option>
                        {timeOptions?.map((opt, index) => (
                          <option key={index}>{opt?.label}</option>
                        ))}
                      </select>
                    </div>

                    <div class="col-3 col-sm-3 col-md-3 mb-2 mb-sm-2 mb-md-0">
                      <div class="mwh-switch">
                        <div class="form-check form-check-inline">
                          <BootstrapSwitchButton
                            width={70}
                            checked={
                              openStatus.includes(
                                CarWashData.calendar.SATURDAY.status
                              )
                                ? true
                                : false
                            }
                            onstyle="warning"
                            onlabel={t('open')}
                            offlabel={t('close')}
                            name="status"
                            id="SATURDAY"
                            onChange={(checked) => {
                              setCarWashData({
                                ...CarWashData,
                                calendar: {
                                  ...CarWashData?.calendar,
                                  SATURDAY: {
                                    ...CarWashData?.calendar?.SATURDAY,

                                    status: checked ? 'OPEN' : 'CLOSE',
                                  },
                                },
                              });
                            }}
                            // value={CarWashData.status}
                          />
                          {/* <input
														class='form-check-input'
														type='checkbox'
														id='inlineCheckbox7'
														value='option7'
													/> */}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row mt-5 ">
                  <div class="col-6">
                    <button
                      type="reset"
                      // onClick={ResetHendler}
                      class="btn btn-secondary btn-block"
                      href="#"
                      onClick={ResetHendler}
                      // role='button'
                    >
                      {t('Reset')}
                    </button>
                  </div>
                  <div class="col-6">
                    <button
                      type="submit"
                      // to='/sp-garages-packages'
                      class="btn btn-warning btn-block"
                      // href='sp-garages-manage-business-packages.html'
                      // role='button'
                    >
                      {t('Submit')}
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CarWashWorkingHours;
